import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";

import FigureCaption from "../../components/LdsFigureCaption";
import LdsContentSlider from "../../components/LdsContentSlider/LdsContentSlider";
import scan1 from "../../assets/module-2/2-3-3-scan1.png";
import scan2 from "../../assets/module-2/2-3-3-scan2.png";
import scan3 from "../../assets/module-2/2-3-3-scan3.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const scan1alt = "A brain scan with a highlighted circle around a specific area labeled 'Slice in question.' Below is a slider tool to view the brain from left to right."
const scan2alt = "A brain scan with a highlighted circle around a specific area labeled 'Slice above.' Below is a slider tool to view the brain from left to right."
const scan3alt = "A brain scan with a highlighted circle around a specific area labeled 'Slice below.' Below is a slider tool to view the brain from left to right."

// Array to hold the images
const scans = [
  { scan: scan1, alt: scan1alt },
  { scan: scan2, alt: scan2alt },
  { scan: scan3, alt: scan3alt }
]


const ImageSlide = ({ src, alt, caption }) => {
  return (
    <div>
      <LdsImage className="content-slider-image" src={src} alt={alt} />
      <FigureCaption
        noCollapse={true}
        className="figcaption-no-border flex-column d-flex"
        radiusSize="small"
      >
        <p className="fz-sm dark-gray">{caption}</p>
      </FigureCaption>
    </div>
  );
};

const getSlides = () => {
  return scans.map((item, index) => (
    <ImageSlide
      key={index}
      src={item.scan}
      alt={item.alt}
      caption="©2016. Avid Radiopharmaceuticals, Inc. All rights reserved. Data on file, Lilly Research Laboratories: AMY20121001O."
    />
  ));
};

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.3 Common Challenges to Image Interpretation
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center mt-5">
            <div className="col-6">
              <LdsContentSlider
                contentItems={getSlides()}
                label={
                  "Use the slider tool to view the brain from the bottom to the top"
                }
              />
            </div>
          </section>

          <section className="row justify-content-center">
            <div className="col-lg-8 col-sm-12 mt-4 mb-4">
              <h5 className="b">Low Contrast</h5>
              <ul className="ms-0">
                <li>
                  Low levels of tracer in scalp or skull must be distinguished
                  from gray matter uptake by its shape and position
                </li>
                <li>
                  <strong>REMINDER</strong>: In a positive scan, an area of reduced or absent gray-white contrast within a lobe of the brain must be larger than a single cortical gyrus and must be seen on at least 2 adjacent slices of the scan
                  <ul className="ms-0">
                    <li>
                      Loss of gray-white contrast cannot be determined based on
                      a single slice
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
